import { Component } from "@angular/core";

@Component({
  selector: "toolbox-icons",
  templateUrl: "./icons.component.html",
  styleUrls: ["./icons.component.scss"],
})
export class IconsComponent {
  logoWidth = 500;
  logoHeight = 100;
  fontColor = "#4c5a66";
  backgroundColor = "#e4e1dc";

  private get sharedStyles(): any {
    return {
      width: `${this.logoWidth}px`,
      height: `${this.logoHeight}px`,
      color: this.fontColor,
      "background-color": this.backgroundColor,
    };
  }

  get svgStyles(): any {
    return { ...this.sharedStyles };
  }

  get iconStyles(): any {
    return {
      ...this.sharedStyles,
      "font-size": `${this.logoHeight}px`,
    };
  }

  get deskBackgroundStyles(): any {
    return {
      ...this.sharedStyles,
      height: `${this.logoWidth}px`,
    };
  }
 }
